import * as React from "react";
import { forwardRef } from "react";
const SvgMinusFat = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, viewBox: "0 0 32 32", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.432 14.393a1.8 1.8 0 0 1 1.8-1.8h21.536a1.8 1.8 0 0 1 1.8 1.8v3.214a1.8 1.8 0 0 1-1.8 1.8H5.232a1.8 1.8 0 0 1-1.8-1.8v-3.214Z" }));
const ForwardRef = forwardRef(SvgMinusFat);
export default ForwardRef;
